import React from "react";
import AppTheme from "../../../../service/app_config/AppTheme";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import { BranchDeptChatsContextImport } from "../../../../provider/branch/branch_dept_chats/BranchDeptChatsContextProvider";

const BranchDeptChatsActions = () => {
  const { showSearch, updateShowSearch } = BranchDeptChatsContextImport();
  return (
    <>
      {!showSearch && (
        <IconNormal
          name="magnify"
          color={AppTheme.themeFont}
          handleClick={() => updateShowSearch()}
        />
      )}
    </>
  );
};

export default BranchDeptChatsActions;
